export enum CardProduct {
  Electron = 'Electron',
  V_Pay = 'V Pay',
}
